"use strict";
exports.__esModule = true;
exports.path = void 0;
var path = function (path) { return function (obj) {
    if (!obj)
        return null;
    var parts = Array.isArray(path) ? path : path.split('.');
    var current = obj;
    var i = 0;
    for (; i < parts.length; i++) {
        var part = parts[i];
        if (current[part] === undefined) {
            return undefined;
        }
        else {
            current = current[part];
        }
    }
    return current;
}; };
exports.path = path;
//# sourceMappingURL=path.js.map